/**
 * SeloDeGarantia — estado da entrega (Contract-Driven, Onda 5 — SPEC-ONDA-5 FR-8).
 *
 * READY_FOR_REVIEW → "Pronta para revisão"; HUMAN_REVIEW_REQUIRED → "Revisão humana";
 * READY_FOR_CLIENT_FINALIZATION → "Pronta para finalização no cliente" (modo de entrega `client`).
 * Estado ausente → não renderiza nada (execução anterior à Onda 5 ou sem cálculo).
 */
import { C } from '@/theme/palette';

export const AJUDA_FINALIZACAO_NO_CLIENTE =
  'As provas foram escritas e serão executadas na finalização, a partir do FINALIZAR.md da entrega.';

const SELO = {
  READY_FOR_REVIEW: ['🟢 Pronta para revisão', C.ok,
    'Verificada, sem correção nem decisão pendente e sem requisito que falhou'],
  HUMAN_REVIEW_REQUIRED: ['🟠 Revisão humana', C.warn,
    'A entrega precisa de revisão humana — veja os motivos'],
  // C.digital: nem o verde de "verificada" nem o âmbar de "revisão humana", em todos os temas.
  READY_FOR_CLIENT_FINALIZATION: ['🔵 Pronta para finalização no cliente', C.digital,
    `Sem pendência nas conferências da plataforma. ${AJUDA_FINALIZACAO_NO_CLIENTE}`],
};

export function SeloDeGarantia({ estado, compacto = false, title }) {
  const par = SELO[estado];
  if (!par) return null;
  const [rotulo, cor, ajuda] = par;
  return (
    <span
      data-testid="selo-garantia"
      title={title || ajuda}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4, borderRadius: 6,
        fontSize: compacto ? 10.5 : 11.5, fontWeight: 700, color: cor,
        border: `1px solid ${cor}66`, padding: compacto ? '1px 6px' : '2px 8px',
        whiteSpace: 'nowrap',
      }}
    >
      {rotulo}
    </span>
  );
}

export default SeloDeGarantia;
